var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibility = function SvgAccessibility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#499D71",
    d: "M7 .5c.825 0 1.5.675 1.5 1.5S7.825 3.5 7 3.5 5.5 2.825 5.5 2 6.175.5 7 .5m6.75 5.25h-4.5v9.75h-1.5V11h-1.5v4.5h-1.5V5.75H.25v-1.5h13.5z"
  })));
};
export default SvgAccessibility;